import React from 'react';

interface MonthlyStatisticsProps {
  totalExceededSales: number;
  totalUnderperformanceSales: number;
  totalDeductionAmount: number;
  totalIncentiveAmount: number;
  userRole?: string;
  userTeamName?: string | null;
}

const MonthlyStatistics: React.FC<MonthlyStatisticsProps> = React.memo(({
  totalExceededSales,
  totalUnderperformanceSales,
  totalDeductionAmount,
  totalIncentiveAmount,
  userRole,
  userTeamName
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-medium text-gray-700 mb-4">
        {userRole === 'employee' && userTeamName ? `${userTeamName} 팀 월간 통계` : '월간 통계'}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">총 초과매출</h3>
          <p className="text-xl font-semibold text-gray-900 tabular-nums">
            {totalExceededSales.toLocaleString()}원
          </p>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">총 미달성매출</h3>
          <p className="text-xl font-semibold text-gray-900 tabular-nums">
            {totalUnderperformanceSales.toLocaleString()}원
          </p>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">총 차감분</h3>
          <p className="text-xl font-semibold text-gray-900 tabular-nums">
            {totalDeductionAmount.toLocaleString()}원
          </p>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">총 인센티브</h3>
          <p className="text-xl font-semibold text-gray-900 tabular-nums">
            {totalIncentiveAmount.toLocaleString()}원
          </p>
        </div>
      </div>
    </div>
  );
});

MonthlyStatistics.displayName = 'MonthlyStatistics';

export default MonthlyStatistics; 